<template>
  <div id="testMethodDetailView">
    <div v-if="$route.name === 'normgroup'">
      <router-view></router-view>
    </div>
    <div v-else>
      <h1>{{ $t('privatePage.testmethod_header') }}</h1>
      <b-tabs>
        <b-tab :title="$t('privatePage.details')" active class="tabContent">
          <test-method-detail-editor :currentTestMethod="currentTestMethod" :instructions="instructions">
          </test-method-detail-editor>
        </b-tab>
        <b-tab :title="$t('content')" v-if="currentTestMethod.id">
          <norm-scale-selector :currentTestMethod="currentTestMethod" :normScales="currentNormScales" :defaultCulture="defaultCulture" :selectedCulture="selectedCulture">
          </norm-scale-selector>
        </b-tab>
        <b-tab :title="$t('privatePage.testmethod_order_header')" v-if="currentTestMethod.id">
          <test-method-questions-order-editor :currentTestMethod="currentTestMethod">
          </test-method-questions-order-editor>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import TestMethodDetailEditor from '../../components/testmethods/standard/testmethoddetaileditor'
import NormScaleSelector from '../../components/testmethods/normscales/normscaleselector'
import TestMethodQuestionsOrderEditor from '../../components/testmethods/standard/testmethodquestionsordereditor'

export default {
  components: {
    TestMethodDetailEditor,
    NormScaleSelector,
    TestMethodQuestionsOrderEditor
  },
  computed: {
    ...mapGetters('testMethodsModule', [
      'currentTestMethod',
      'currentNormScales'
    ]),
    ...mapGetters(['selectedCulture', 'defaultCulture']),
    ...mapGetters('instructionsModule', ['instructions']),
    scales: function() {
      let arr = []

      if (this.currentTestMethodScales.constructor === Array) {
        this.currentTestMethodScales.forEach(scale => {
          if (scale.selected) {
            arr.push(scale)
          }
        })
      }
      return arr
    }
  },
  methods: {
    ...mapActions('testMethodsModule', {
      getTestMethodScales: 'getTestMethodScales',
      selectTestMethodScales: 'selectTestMethodScales',
      getNormGroups: 'getNormGroups',
      selectTestMethodNormGroups: 'selectTestMethodNormGroups',
      getNormScales: 'getNormScales'
    })
  },
  created() {
    if (this.currentTestMethod && this.currentTestMethod.id) {
      this.getNormScales({
        testMethodId: this.currentTestMethod.id,
        languageId: this.selectedCulture.languageId,
        defaultLanguageId: this.defaultCulture.languageId
      })
    }
  }
}
</script>

<style>
.tabContent {
  margin-top: 30px;
}
</style>
